<template>
  <div>
    <button
      @click.prevent="favourite"
      class="btn btn--quaternary btn--full mt10 favourite-btn"
    >
      <svg
        :class="{ favourited: favourited }"
        xmlns="http://www.w3.org/2000/svg"
        class="icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
        />
      </svg>

      {{ favourited ? __("Favourited") : __("Favourite") }}
    </button>
  </div>
</template>

<script>
import { Form } from "vform";
export default {
  props: {
    schedule: {
      type: Object,
      required: true,
    },
  },
  computed: {
    customer() {
      return window.customer;
    },
  },
  created() {
    if (!this.customer) {
      return;
    }
    var index = this.customer.favourites.findIndex((favourite) => {
      return favourite.event_schedules_id == this.schedule.id;
    });

    if (index > -1) {
      this.favourited = true;
    }
  },
  data() {
    return {
      favourited: false,
      form: new Form(),
    };
  },
  methods: {
    favourite() {
      if (!this.customer) {
        this.$root.user.opened = true;
        this.$root.user.redirect = window.location.pathname;
        return;
      }

      this.form
        .post("/account/favourite/" + this.schedule.id)
        .then((response) => {
          this.favourited = !this.favourited;
        });
    },
  },
};
</script>

<style scoped>
button {
  position: relative;
}
.icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-right: 2px;
  position: absolute;
  transform: translateX(-25px) translateY(-2px);
}
.icon.favourited path {
  fill: white;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Account/favourite-button.vue